import { gql } from '@apollo/client';

// Kept out of WarrantyInfoShared deliberately: stateReversalPreview is an
// admin_only field, so including it in the shared fragment would break the
// partner and customer queries that also use that fragment.
export default gql`
  query warrantyStateReversalPreview($id: ID!) {
    warranty(id: $id) {
      id
      hexCode
      state
      stateReversalPreview {
        currentState
        reversible
        blockers
        warnings
        targetStates
        minimumReasonLength
        productionOrders {
          id
          hexCode
          state
          deletable
          itemCount
          createdAt
        }
      }
    }
  }
`;
